import { v4 as uuidv4 } from 'uuid'
import { user } from 'ampersand-app'

const isLoggingEnabled = () => {
  return user.get('bankingLogsEnabled')
}

export const generateProcessId = () => {
  if (isLoggingEnabled()) {
    return uuidv4()
  }
  return null
}

export const getProcessIdHeader = (processId) => {
  if (processId) {
    return { processid: processId }
  }
  return {}
}
